import multiGuard from '@/router/utils/vue-router-multiguard'
import USER_TYPES from '@/constants/authorization/user-types'
import TabletGuard from '@/router/guards/tablet-guard'
import PackagePermissionsGuard from '@/router/guards/package-permissions-guard'
import { PACKAGE_PERMISSIONS } from '@/constants/features'

export default [
  {
    path: 'users-wizard',
    name: 'admin:users-wizard',
    alias: '/admin/users',
    meta: { userTypes: [USER_TYPES.OWNER] },
    component: () => import(/* webpackChunkName: "basic-info" */ '@/views/admin/setup/account-basics/users-notifications/UsersNotificationsWizard.vue'),
  },
  {
    path: 'services-wizard',
    name: 'admin:services-wizard',
    component: () => import(/* webpackChunkName: "ordering" */ '@/views/admin/setup/ordering/services/ServicesWizard.vue'),
  },
  {
    path: 'payment-methods-wizard',
    name: 'admin:payment-methods-wizard',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "ordering" */ '@/views/admin/setup/ordering/payment-methods/PaymentMethodsWizard.vue'),
  },
  {
    path: 'vendor',
    name: 'admin:vendor',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "ordering" */ '@/views/admin/setup/ordering/vendor-business-account/VendorBusinessAccountWizard.vue'),
  },
  {
    path: 'opening-hours',
    name: 'admin:opening-hours-wizard',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "shifts" */ '@/views/admin/setup/organizing/opening-hours-scheduled-orders/OpeningHoursPage.vue'),
  },
  {
    path: 'my-menu',
    name: 'admin:my-menu',
    alias: '/admin/menu',
    meta: {
      hideFooter: true,
      collapseNavigation: true,
      userTypes: [USER_TYPES.BRANCH_ADMIN],
    },
    component: () => import(/* webpackChunkName: "my-menu" */ '@/views/admin/setup/menu-setup/my-menu/MyMenu.vue'),
  },
  {
    path: 'pos-menu',
    name: 'admin:pos-menu',
    alias: '/admin/pos-menu',
    meta: {
      hideFooter: true,
      collapseNavigation: true,
      pos: true,
      userTypes: [USER_TYPES.BRANCH_ADMIN],
    },
    component: () => import(/* webpackChunkName: "pos-menu" */ '@/views/admin/setup/menu-setup/my-menu/MyMenu.vue'),
  },
  {
    path: 'modifiers',
    name: 'admin:modifiers',
    alias: '/admin/modifiers',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "modifiers" */ '@/views/admin/setup/menu-setup/modifiers/ModifiersTable.vue'),
  },
  {
    path: 'cloud',
    name: 'admin:cloud',
    component: () => import(/* webpackChunkName: "cloud" */ '@/views/admin/design/cloud/CloudWizard.vue'),
  },
  {
    path: 'cloud-table',
    name: 'admin:cloud-table',
    component: () => import(/* webpackChunkName: "cloud" */ '@/views/admin/design/cloud/CloudTable.vue'),
  },
  {
    path: 'taxes',
    name: 'admin:taxes',
    component: () => import(/* webpackChunkName: "taxes" */ '@/views/admin/setup/menu-setup/taxes/TaxPage.vue'),
  },
  {
    path: 'qr',
    name: 'admin:qr',
    meta: { userTypes: [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "qr" */ '@/views/admin/setup/publishing/qr/QRCodeTable.vue'),
  },
  {
    path: 'devices',
    name: 'admin:devices',
    meta: { userTypes: [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN], packagePermissions: [PACKAGE_PERMISSIONS.RESERVATION, PACKAGE_PERMISSIONS.QUEUE] },
    beforeEnter: multiGuard([TabletGuard, PackagePermissionsGuard]),
    component: () => import(/* webpackChunkName: "devices" */ '@/views/admin/setup/publishing/devices/DevicesTable.vue'),
  },
  {
    path: 'widget',
    name: 'admin:widget',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "widget" */ '@/views/admin/setup/publishing/widget/WidgetWizard.vue'),
  },
  {
    path: 'domain',
    name: 'admin:domain',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "domain" */ '@/views/admin/setup/publishing/domain/DomainWizard.vue'),
  },
  {
    path: 'google-menu',
    name: 'admin:google-menu',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "google" */ '@/views/admin/setup/publishing/viral/GoogleMenuWizard.vue'),
  },
  {
    path: 'dynamic-links',
    name: 'admin:dynamic-links',
    component: () => import(/* webpackChunkName: "dynamicLinks" */ '@/views/admin/user/dynamic-links/UrlsTable.vue'),
  },
]
